/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 *
 * This  software  has  been  provided pursuant  to  a  License
 * Agreement  containing  restrictions on  its  use.   The  software
 * contains  valuable  trade secrets and proprietary information  of
 * Pegasystems Inc and is protected by  federal   copyright law.  It
 * may  not be copied,  modified,  translated or distributed in  any
 * form or medium,  disclosed to third parties or used in any manner
 * not provided for in  said  License Agreement except with  written
 * authorization from Pegasystems Inc.
 */

import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import constants from '../constants';
import { FETCH_DATAPAGE } from '../store/state/actions';
import { mergeData, addSharedData } from '../store/state/actions/action-creators';
import { getSharedDataObject, dispatch, type Action } from '../store/state/state-manager';

import DataApiUtils from './data-api-utils';

export const fetchDataPage = (action$: Observable<Action>) =>
  action$.pipe(
    ofType(FETCH_DATAPAGE),

    // eslint-disable-next-line sonarjs/cognitive-complexity
    mergeMap(async (action: Action) => {
      const { context } = action.payload;
      const data: { [key: string]: any } = {};
      const sharedData: { [key: string]: any } = {};
      const promises = Object.keys(action.payload.datapages).map((datapageKey) => {
        const datapage = action.payload.datapages[datapageKey];
        if (datapage.mode === constants.READONLY && datapage?.refreshStrategy) {
          const { timeoutSecs = '', type = '' } = datapage?.refreshStrategy || {};
          const dataPageObjectFromStore = getSharedDataObject()?.[datapage.name];
          if (dataPageObjectFromStore && datapageKey in dataPageObjectFromStore) {
            const dataPageWithHash = dataPageObjectFromStore[datapageKey];
            const { loadTime } = dataPageWithHash;
            if (!DataApiUtils.isTimeElapsed(loadTime, timeoutSecs, type)) {
              return;
            }
          }
        }
        return DataApiUtils.getData(
          datapage.name,
          {
            dataViewParameters: datapage.dataViewParameters
          },
          context
        )
          .then((response) => {
            const dataOf = datapage.mode === constants.READONLY ? sharedData : data;

            if (dataOf[datapage.name]) {
              dataOf[datapage.name][datapageKey] = {
                pxResults: response.data.data,
                parameters: datapage.dataViewParameters,
                loadTime: response.data?.fetchDateTime
              };
            } else {
              dataOf[datapage.name] = {
                [datapageKey]: {
                  pxResults: response.data.data,
                  parameters: datapage.dataViewParameters,
                  loadTime: response.data?.fetchDateTime
                }
              };
            }
          })
          .catch(() => {
            // TODO: handle failure cases
          });
      });
      await Promise.allSettled(promises);
      const actionsOut: any[] = [];
      if (Object.keys(data).length) {
        actionsOut.push(
          mergeData({
            context,
            data
          })
        );
      }
      if (Object.keys(sharedData).length) {
        actionsOut.push(
          addSharedData({
            data: sharedData,
            context
          })
        );
      }
      dispatch(actionsOut);
      return [];
    })
  );
const dataViewEpic = [fetchDataPage];
export default dataViewEpic;
